"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const utils_1 = require("../utils");
const updateItem = (item, reason) => {
    item.status = domain_1.OrderItemStatus.VOID;
    item.reason = reason;
    item.itemFired = false;
};
/**
 * Set status of order to VOID
 * Can only be done when the order is in IN_PROGRESS status
 * @param event of type VoidOrderEvent
 * @param prevState
 */
function default_1(event, prevState = {}) {
    var _a;
    const order = (0, utils_1.clone)(prevState);
    if ([domain_1.OrderStatus.IN_PROGRESS, domain_1.OrderStatus.ON_HOLD].includes(prevState.status)) {
        order.status = domain_1.OrderStatus.VOID;
        order.reason = event.reason;
        if (order.orderItems) {
            // Voiding items which are non cancelled and non voided.
            order.orderItems.forEach(item => {
                var _a;
                if (!utils_1.INVALID_VOID_ITEM_STATUS.includes(item.status)) {
                    updateItem(item, event.reason);
                    // Update combo item status
                    (_a = item.comboItems) === null || _a === void 0 ? void 0 : _a.forEach(comboItem => {
                        if (!utils_1.INVALID_VOID_ITEM_STATUS.includes(comboItem.status))
                            updateItem(comboItem, event.reason);
                    });
                }
            });
        }
        const tables = (0, utils_1.getTablesFromOrder)(order);
        const updatedTables = tables.map(table => ({
            ...table,
            status: domain_1.TableStatus.AVAILABLE,
        }));
        order.tables = updatedTables;
        order.table = updatedTables[0];
        // remove prepayments from the order if voided
        order.payments = (_a = order.payments) === null || _a === void 0 ? void 0 : _a.filter(payment => !payment.isPrePayment);
    }
    return order;
}
exports.default = default_1;
//# sourceMappingURL=voidOrder.js.map